import type { FC } from 'react';
import { memo } from 'react';
import { Link } from '@compat/router';
import FooterSocialIcons from './FooterSocialIcons';

const currentYear = new Date().getFullYear();

const CreateOrderFooter: FC = () => (
  <div className='desktop-footer'>
    <div className='question-new'>
      <div className='main-container'>
        <span>
          <b>Есть вопросы? </b> Звоните
        </span>
        <span>
          <a href='tel:+74956409640'>
            <b> +7 495 640 9 640 </b>
          </a>{' '}
          с 06:00 до 00:00
        </span>
      </div>
    </div>
    <div className='sm:pb-32 main-container'>
      <aside className='aside'>
        <div className='copyright'>
          © {currentYear} Деликатеска.ру - интернет-магазин продуктов.{' '}
          <span>Все права защищены</span>
        </div>
        <div className='flex-links'>
          <FooterSocialIcons isDarkGrey />
        </div>
      </aside>
      <div className='text-xs text-[#5E5F61] pb-3'>
        <div className='flex gap-6 sm:flex-col sm:gap-3 sm:px-3 md:justify-center'>
          <Link
            to='/license-agreement'
            className='underline hover:text-[var(--dark-red)] transition-colors'
          >
            Пользовательское соглашение
          </Link>
          <Link
            to='/confidential'
            className='underline hover:text-[var(--dark-red)] transition-colors'
          >
            Политика конфиденциальности
          </Link>
          <Link
            to='/pdn'
            className='underline hover:text-[var(--dark-red)] transition-colors'
          >
            Согласие на обработку персональных данных
          </Link>
        </div>
      </div>
    </div>
  </div>
);

export default memo(CreateOrderFooter);
